import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy px-md lg:px-xl py-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-md">
          <div className="font-display text-base sm:text-lg text-cream">
            The Poetic Method™
          </div>
          <nav aria-label="Footer navigation">
            <ul className="flex flex-wrap gap-lg justify-center">
              <li>
                <Link
                  to="/about"
                  className="font-body text-xs sm:text-sm text-cream transition-colors duration-150 hover:text-white focus:outline-2 focus:outline-cream"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/partnerships"
                  className="font-body text-xs sm:text-sm text-cream transition-colors duration-150 hover:text-white focus:outline-2 focus:outline-cream"
                >
                  Partnerships
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-body text-xs sm:text-sm text-cream transition-colors duration-150 hover:text-white focus:outline-2 focus:outline-cream"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Legal Links */}
        <div className="mt-lg pt-lg border-t border-cream/20 flex flex-col sm:flex-row justify-between items-center gap-md">
          <p className="font-body text-xs sm:text-sm text-cream/90">
            © {currentYear} The Poetic Method™. All rights reserved.
          </p>
          <nav aria-label="Legal navigation">
            <ul className="flex gap-md">
              <li>
                <Link
                  to="/privacy"
                  className="font-body text-xs sm:text-sm text-cream/90 transition-colors duration-150 hover:text-white focus:outline-2 focus:outline-cream"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="font-body text-xs sm:text-sm text-cream/90 transition-colors duration-150 hover:text-white focus:outline-2 focus:outline-cream"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
